import React, { useEffect } from 'react';
import Header from '../headerFooter/header';
import HomeFooter from '../homepage/homefooter';
import './Legal.css'; // Updated CSS import

const TermsAndConditions = () => {
  // Ensure page starts at top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="legal-page-wrapper">
        <div className="legal-doc-container">
          <h1>Terms & Conditions</h1>
          <span className="effective-date">Effective Date: August 5, 2025</span>

          <p>
            Welcome to Satvic Path! These Terms & Conditions ("Terms") govern your use of our website, 
            <a href="https://satvicpath.com" target="_blank" rel="noopener noreferrer"> satvicpath.com</a> (the "Website"), 
            and all related content, services, and products, including our books, classes, and blogs (collectively, the "Services").
          </p>
          <p>
            By accessing or using our Services, you acknowledge and accept these Terms and our Privacy Policy. If you do not agree, you may not use our Services.
          </p>

          <h2>1. Definitions</h2>
          <ul>
            <li><strong>"We," "us," "our,"</strong> and <strong>"Satvic Path"</strong> refer to the owners and operators of the Satvic Path website.</li>
            <li><strong>"You"</strong> and <strong>"user"</strong> refer to any visitor, subscriber, or customer using our Website and Services.</li>
          </ul>

          <h2>2. Use of Our Services</h2>
          <ul>
            <li><strong>Eligibility:</strong> You must be at least 12 years of age to use or purchase any of our Services. By using our Services, you represent and warrant that you have the legal capacity to enter into a binding contract.</li>
            <li><strong>User Accounts:</strong> To access certain features, such as our paid classes, you may need to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use.</li>
          </ul>

          <h2>3. Health & Medical Disclaimer</h2>
          <ul>
            <li><strong>Not Medical Advice:</strong> The content provided through Satvic Path—including blogs, books, and classes—is for informational and educational purposes only. It is not intended to substitute professional medical advice, diagnosis, or treatment.</li>
            <li><strong>Consult Your Doctor:</strong> Always seek the advice of a qualified healthcare provider regarding any medical condition. Never disregard or delay professional medical advice because of content you accessed through our Services.</li>
            <li><strong>No Guarantees:</strong> Satvic Path makes no guarantees about the outcomes you may experience. Results depend on personal health, genetics, lifestyle, and commitment.</li>
            <li><strong>Risk Acknowledgment:</strong> Participation in any class or use of any product is at your own risk. Satvic Path shall not be held liable for any injuries or health issues resulting from use of our Services.</li>
          </ul>

          <h2>4. Purchases and Payments</h2>
          <ul>
            <li><strong>Products and Services:</strong> We offer e-books, physical books, and online classes for sale. All prices are listed in Indian Rupees (INR), unless otherwise specified.</li>
            <li><strong>Payment:</strong> We use third-party payment processors (e.g., Razorpay, Stripe) to handle transactions securely. By making a purchase, you agree to the terms and conditions of the respective payment gateway. We do not store your full credit or debit card information on our servers.</li>
            <li><strong>Order Confirmation:</strong> Upon successful completion of a purchase, you will receive an email and/or SMS confirmation containing access details for your digital products or classes.</li>
          </ul>

          <h2>5. Refund and Cancellation Policy</h2>
          <ul>
            <li><strong>Digital Products (E-books):</strong> All sales of digital products are final, non-refundable, and non-transferable. Please review product details before purchase.</li>
            <li><strong>Online Classes:</strong> Class bookings are non-refundable and non-transferable, regardless of the reason for cancellation or absence. By registering, you acknowledge and accept this strict no-refund policy.</li>
            <li><strong>Physical Books:</strong> If you receive a damaged or incorrect book, contact us within 7 days of delivery at <strong>team@satvicpath.com</strong>, with photographic evidence. We will provide a replacement or refund at our sole discretion.</li>
          </ul>
          <blockquote>
            <p><strong>Note:</strong> All purchases are final. Please read all product/class descriptions carefully before making a payment.</p>
          </blockquote>
          
          <h2>6. Intellectual Property</h2>
          <p>All content made available through our Services—including text, images, graphics, audio, video, logos, and downloads—is the exclusive property of Satvic Path or its content partners. It is protected under Indian and international copyright laws. You may not copy, reproduce, distribute, modify, publish, create derivative works of, publicly display, or otherwise exploit any part of our content without prior written permission.</p>
          
          <h2>7. User Conduct</h2>
          <p>You agree not to use the Website or Services to:</p>
          <ul>
            <li>Post or transmit any unlawful, harassing, defamatory, abusive, or obscene material.</li>
            <li>Infringe on the intellectual property rights of others.</li>
            <li>Distribute spam, unsolicited messages, or chain letters.</li>
            <li>Attempt unauthorized access to our systems, user data, or accounts.</li>
            <li>Disrupt, damage, or interfere with the performance or security of our Website or Services.</li>
          </ul>

          <h2>8. Limitation of Liability</h2>
          <p>To the fullest extent permitted by law, Satvic Path shall not be liable for any indirect, incidental, special, consequential, or punitive damages—including loss of profits, data, goodwill, or use—arising from:</p>
          <ul>
            <li>Your access to or use of (or inability to access or use) our Services.</li>
            <li>The conduct or content of any third party.</li>
            <li>Unauthorized access to or alteration of your transmissions or data.</li>
          </ul>
          <blockquote>
            <p>Your sole and exclusive remedy for dissatisfaction with the Services is to discontinue using them.</p>
          </blockquote>

          <h2>9. Governing Law and Jurisdiction</h2>
          <p>These Terms shall be governed by the laws of India. Any disputes arising from these Terms or your use of our Services shall fall under the exclusive jurisdiction of the courts located in Jodhpur, Rajasthan, India.</p>
          
          <h2>10. Changes to These Terms</h2>
          <p>We reserve the right to modify these Terms at any time. We will notify users of changes by updating the "Effective Date" at the top of this page. Continued use of the Services after such changes constitutes acceptance of the revised Terms.</p>
          
          <h2>11. Contact Us</h2>
          <p>For any questions, concerns, or support regarding these Terms, you can reach us at:</p>
          <p>
            <strong>Satvic Path</strong><br/>
            📧 Email: <strong><a href="mailto:team@satvicpath@gmail.com">team@satvicpath@gmail.com</a></strong>
          </p>
        </div>
      </div>
      <HomeFooter />
    </>
  );
};

export default TermsAndConditions;